import { KeycloakConfig } from 'keycloak-js';

interface RuntimeEnvironment {
    keycloakUrl: string;
    keycloakRealm: string;
    keycloakClientId: string;
    basePath: string;
    employeePortalUrl: string;
    infinkonSender: string;
    requiredRole: string;
    adminRole: string;
    iotaAdminRole: string;
    basePathCdn: string;
    basePathCore: string;
    exportCasesMailFrom: string;
    exportCasesMailTo: string;
    exportCasesMailCc?: string;
    exportCasesMailBcc?: string;
    environmentHeaderColor: string;
    enableLogging: boolean;
    appVersion: string;
}

declare global {
    interface Window {
        __env?: Partial<RuntimeEnvironment>;
    }
}

const runtimeEnvironment = window.__env;
if (!runtimeEnvironment) {
    throw new Error('Runtime config missing: /runtime-config/env.js did not set window.__env');
}

const missingKeys: string[] = [];

function required<K extends keyof RuntimeEnvironment>(key: K): RuntimeEnvironment[K] {
    const value = runtimeEnvironment![key];
    // A presence check, not a truthiness check: false and '' are valid values.
    if (value === undefined || value === null) {
        missingKeys.push(key);
    }
    return value as RuntimeEnvironment[K];
}

const keycloakConfig: KeycloakConfig = {
    url: required('keycloakUrl'),
    realm: required('keycloakRealm'),
    clientId: required('keycloakClientId')
};

export const environment = {
    production: true,
    keycloak: keycloakConfig,
    basePath: required('basePath'),
    employeePortalUrl: required('employeePortalUrl'),
    keycloakAdminUserUrl: keycloakConfig.url + '/admin/master/console/#/iota-external/users/',
    infinkonSender: required('infinkonSender'),
    requiredRole: required('requiredRole'),
    adminRole: required('adminRole'),
    iotaAdminRole: required('iotaAdminRole'),
    basePathCdn: required('basePathCdn'),
    basePathCore: required('basePathCore'),
    exportCasesMailFrom: required('exportCasesMailFrom'),
    exportCasesMailTo: required('exportCasesMailTo'),
    exportCasesMailCc: runtimeEnvironment.exportCasesMailCc,
    exportCasesMailBcc: runtimeEnvironment.exportCasesMailBcc,
    environmentHeaderColor: required('environmentHeaderColor'),
    enableLogging: required('enableLogging'),
    isLocalhost: false,
    appVersion: required('appVersion')
};

if (missingKeys.length > 0) {
    throw new Error(`Runtime config incomplete, missing keys: ${missingKeys.join(', ')}`);
}
